<div class="elevation-container">
  <ng-container *ngIf="titleTag; then tag; else set"></ng-container>
</div>
<ng-template #tag>
  <div class="checkbox-container">
    <mat-checkbox disableRipple [checked]="forceSelectAll || selectedAll" (change)="onSelectedAll()">{{ formatName(titleTag.ttl_kbntag)
      }}</mat-checkbox>
  </div>
  <mat-expansion-panel class="mat-elevation-z0" [expanded]="expandItem">
    <mat-expansion-panel-header class="title-set">
      <div class="stuffed"></div>
    </mat-expansion-panel-header>
    <div class="checkbox-group">
      <mat-checkbox *ngFor="let item of titleTag.titles; index as i" [checked]="forceSelectAll || $any(form.at(i)).value" [formControl]="$any(form.at(i))" disableRipple
        (change)="onChange()">{{ formatName(item.ttltag) }}</mat-checkbox>
    </div>
  </mat-expansion-panel>
</ng-template>

<ng-template #set>
  <div class="checkbox-container">
    <mat-checkbox disableRipple [checked]="forceSelectAll || selectedAll" (change)="onSelectedAll()">{{titleSet.ttlnm }}</mat-checkbox>
  </div>
  <mat-expansion-panel class="mat-elevation-z0" [expanded]="expandItem">
    <mat-expansion-panel-header class="title-set">
      <div class="stuffed"></div>
    </mat-expansion-panel-header>
    <div class="checkbox-group">
      <mat-checkbox *ngFor="let item of titleSet.titles; index as i" [checked]="forceSelectAll || $any(form.at(i)).value" [formControl]="$any(form.at(i))" disableRipple
        (change)="onChange()">{{ item.ttlnm }}</mat-checkbox>
    </div>
  </mat-expansion-panel>
</ng-template>